import { Modal } from '../../../shared/ui/modal';
import { FactList, FactRow } from '../../../shared/ui/fact-list';
import { Button } from '../../../shared/ui/button';
import {
  BuiltinTag,
  isReplayable,
  parseSummary,
  ReplayNote,
  type TAuthPreset,
  type TAuthPresetSpec,
} from '../../../entities/auth-preset';
import { PresetDuplicate } from '../../preset-duplicate';
import { PresetExport } from '../../preset-export';
import { PresetImport } from '../../preset-import';
import { VersionsPanel } from '../../preset-versions';

interface ISchemeDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  preset: TAuthPreset;
  /** The version this source is pinned to, never the preset's latest — it is what gets exported. */
  version: number;
  spec: TAuthPresetSpec;
  onCatalogue: () => void;
}

export const SchemeDialog = ({
  open,
  onOpenChange,
  preset,
  version,
  spec,
  onCatalogue,
}: ISchemeDialogProps) => {
  const elsewhere = () => {
    onOpenChange(false);
    onCatalogue();
  };

  return (
    <Modal
      open={open}
      onOpenChange={onOpenChange}
      width="lg"
      title={preset.name}
      description={
        preset.builtin ? 'Ships with the product, so the fields here cannot be edited.' : undefined
      }
      footerNote={preset.builtin ? 'Nothing here is editable' : undefined}
      footer={
        preset.builtin ? (
          <PresetDuplicate preset={preset} onDuplicated={elsewhere} />
        ) : (
          <Button size="sm" variant="ghost" onClick={() => onOpenChange(false)}>
            Close
          </Button>
        )
      }
    >
      <div className="max-h-body overflow-y-auto">
        {preset.builtin && (
          <div className="mb-3">
            <BuiltinTag />
          </div>
        )}

        <FactList>
          <FactRow label="Algorithm" mono>
            {spec.signature.algorithm} · {spec.signature.encoding}
          </FactRow>
          <FactRow label="Reads" mono>
            {spec.signature.location.header}
          </FactRow>
          <FactRow label="Value looks like" mono>
            {parseSummary(spec.signature.location.parse)}
          </FactRow>
          <FactRow label="Signs" mono>
            {spec.signature.template}
          </FactRow>
        </FactList>

        {isReplayable(spec) && <ReplayNote name={preset.name} className="mt-3" />}

        <div className="mt-5">
          <VersionsPanel presetId={preset.id} builtin={preset.builtin} />
        </div>

        <div className="mt-5">
          <PresetExport presetId={preset.id} version={version} fileKey={preset.key} />
          <div className="mt-3">
            <PresetImport onImported={elsewhere} />
          </div>
        </div>
      </div>
    </Modal>
  );
};
